import React, { useMemo } from 'react';
import { SystemCard } from '../components/SystemCard';
import { SystemCardPopoverContent } from '../components/SystemCardPopoverContent';
import { CookingWithMetrics } from '../types';
import { iconForEnergySink, isPassiveTechnology } from '../utils';

const COOKING_SYSTEM_IMAGE = (
  <svg
    width='61'
    height='61'
    viewBox='0 0 61 61'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M30.9306 17.074C30.9297 17.0723 30.9288 17.0706 29.2784 17.8989C27.6279 18.7273 27.627 18.7255 27.6262 18.7238L27.6244 18.7203L27.6209 18.7131L27.6137 18.6981C27.6088 18.6879 27.6037 18.6771 27.5986 18.6658C27.5883 18.6432 27.5774 18.6186 27.5663 18.5918C27.544 18.5382 27.5203 18.4764 27.4965 18.4059C27.4487 18.2649 27.4005 18.0909 27.3606 17.8821C27.2803 17.4634 27.2348 16.9151 27.284 16.2234C27.3822 14.844 27.8557 12.9088 29.1656 10.279C30.1134 8.37641 29.7627 7.17452 29.3616 6.45875C29.1349 6.05431 28.8512 5.74114 28.6195 5.5285C28.5057 5.42406 28.4108 5.34968 28.3519 5.30621C28.3227 5.28464 28.3031 5.27123 28.2954 5.26604L28.2933 5.26462L28.2996 5.26866L28.3048 5.27188L28.3078 5.27379L28.3095 5.27482C28.3104 5.27536 28.3113 5.27591 29.2784 3.69843C30.2455 2.12095 30.2464 2.12152 30.2473 2.12209L30.2493 2.12329L30.2534 2.12588L30.2629 2.13182L30.2862 2.14671C30.3037 2.15799 30.3251 2.17198 30.35 2.1887C30.3996 2.2221 30.4635 2.26657 30.5388 2.32218C30.689 2.43307 30.8872 2.59021 31.1098 2.79448C31.5508 3.19925 32.1129 3.81221 32.5782 4.64259C33.5611 6.39647 33.9792 8.89906 32.4666 11.9357C31.3161 14.2453 31.0208 15.7059 30.9652 16.4874C30.9375 16.8761 30.9689 17.0996 30.9847 17.1826C30.9898 17.209 30.9935 17.2225 30.9939 17.2238L30.9935 17.2223L30.9906 17.2135C30.9872 17.2033 30.9809 17.1861 30.9709 17.1621C30.9659 17.1501 30.96 17.1364 30.953 17.1211L30.9461 17.1062L30.9418 17.097L30.9355 17.0841L30.9322 17.0774L30.9306 17.074ZM22.3961 18.006C22.3956 18.0043 22.3951 18.0026 20.6222 18.5163C18.8493 19.0301 18.8489 19.0284 18.8484 19.0267L18.8474 19.0232L18.8454 19.0162L18.8415 19.0018C18.8388 18.9921 18.8361 18.982 18.8335 18.9715C18.8282 18.9506 18.8228 18.9284 18.8175 18.9047C18.807 18.8574 18.7967 18.8047 18.7873 18.7462C18.7683 18.6293 18.7529 18.4904 18.7452 18.3278C18.7298 18.0025 18.7456 17.5848 18.8259 17.0605C18.9859 16.016 19.4043 14.532 20.3654 12.4802C20.9899 11.147 20.7138 10.3282 20.4197 9.82931C20.2482 9.53852 20.0361 9.309 19.862 9.15149C19.7771 9.07466 19.7076 9.02063 19.6665 8.99045C19.6462 8.97551 19.6336 8.96692 19.6304 8.9648C19.6289 8.96375 19.6298 8.96436 19.6333 8.96663L19.6406 8.9713L19.6458 8.97459L19.6488 8.97647L19.6504 8.97747C19.6513 8.97799 19.6521 8.97851 20.6222 7.40291C21.5924 5.82731 21.5933 5.82785 21.5941 5.8284L21.596 5.82953L21.5999 5.83196L21.6086 5.83745L21.6296 5.8509C21.6452 5.86097 21.664 5.87328 21.6856 5.88782C21.7287 5.91688 21.7836 5.95504 21.8479 6.00234C21.9761 6.09662 22.1442 6.22903 22.3333 6.40009C22.7071 6.73836 23.1877 7.25041 23.5958 7.94278C24.4609 9.41021 24.8913 11.5242 23.7052 14.0564C22.8556 15.8702 22.5675 17.0102 22.4736 17.6233C22.427 17.9279 22.429 18.0973 22.4316 18.1521C22.4323 18.1658 22.433 18.1725 22.433 18.1725C22.433 18.1725 22.4323 18.1657 22.4301 18.1526C22.428 18.1395 22.4245 18.1202 22.4189 18.095C22.4175 18.0886 22.4159 18.0817 22.4142 18.0745C22.4125 18.0677 22.4107 18.0605 22.4088 18.053C22.4069 18.0453 22.4047 18.0372 22.4025 18.0288L22.3989 18.016L22.3971 18.0094L22.3961 18.006ZM39.5165 17.1142C39.5157 17.1125 39.5149 17.1108 37.845 17.8989C36.1751 18.687 36.1743 18.6854 36.1735 18.6837L36.1719 18.6802L36.1687 18.6733L36.1622 18.6589C36.1578 18.6491 36.1533 18.6389 36.1487 18.6283C36.1396 18.6071 36.1302 18.5843 36.1206 18.5598C36.1014 18.5108 36.0815 18.4553 36.0617 18.3932C36.022 18.2687 35.9832 18.1186 35.9513 17.9416C35.8874 17.5867 35.8529 17.1319 35.8907 16.5668C35.9661 15.4399 36.328 13.8851 37.3067 11.7957C38.089 10.1255 38.1611 8.99844 38.111 8.38674C38.0854 8.07425 38.026 7.87067 37.991 7.77269C37.9733 7.72308 37.9612 7.69876 37.9617 7.69966C37.9619 7.70009 37.9652 7.70681 37.9726 7.71983C37.9752 7.72454 37.9784 7.73009 37.9821 7.73646C37.9836 7.73888 37.9851 7.74142 37.9867 7.74408L37.9962 7.75977L38.0016 7.7685L38.0045 7.77309L38.0059 7.77544C38.0067 7.77663 38.0074 7.77782 39.5656 6.7855C41.1237 5.79317 41.1245 5.79438 41.1252 5.7956L41.1268 5.79808L41.13 5.8032L41.1367 5.81405L41.1514 5.83823C41.1617 5.85544 41.173 5.87485 41.1851 5.89646C41.2095 5.93967 41.2373 5.99169 41.2674 6.05253C41.3276 6.17422 41.3968 6.33111 41.4653 6.52309C41.6028 6.90831 41.7357 7.42951 41.7892 8.08341C41.8973 9.40448 41.6749 11.1766 40.6466 13.3719C39.8146 15.1481 39.6107 16.2508 39.573 16.8151C39.5542 17.0955 39.5762 17.2447 39.583 17.2824C39.5843 17.2898 39.5852 17.2934 39.5852 17.2934C39.5852 17.2934 39.5829 17.2837 39.577 17.265C39.5722 17.2501 39.5651 17.2295 39.555 17.2036C39.5499 17.1907 39.5441 17.1765 39.5374 17.161C39.5341 17.1532 39.5306 17.1452 39.5268 17.1368L39.521 17.1241L39.518 17.1175L39.5165 17.1142ZM5.73519 29.6298H54.943V27.1601C54.943 23.7503 52.1891 20.986 48.792 20.986H11.8862C8.48907 20.986 5.73519 23.7503 5.73519 27.1601V29.6298ZM54.943 37.6562H57.4034V33.3343H3.88989V37.6562H5.73519V54.3263C5.73519 57.7362 8.48907 60.5005 11.8862 60.5005H48.792C52.1891 60.5005 54.943 57.7362 54.943 54.3263V37.6562Z'
      fill='currentColor'
    />
  </svg>
);

type CookingUnitProps = {
  cookingSystem: CookingWithMetrics;
  selected: boolean;
  count?: number;
  isLoading?: boolean;
  readOnly?: boolean;
  actions: {
    onAdd?: () => void;
    onIncrement?: () => void;
    onDecrement?: () => void;
    onRemove?: () => void;
    onChangeCount?: (newCount: number) => void;
  };
};

export const CookingUnit: React.FC<CookingUnitProps> = React.memo(
  ({ cookingSystem, selected, count, isLoading, actions, readOnly }) => {
    const EnergyIcon = iconForEnergySink(cookingSystem.energySink);

    const icons = useMemo(
      () => ({
        EnergyIcon: EnergyIcon,
        energyIconCount: cookingSystem.relativeEnergyDemand,
        costIconCount: cookingSystem.relativeCost,
      }),
      [
        EnergyIcon,
        cookingSystem.relativeEnergyDemand,
        cookingSystem.relativeCost,
      ],
    );

    const hoverPopover = useMemo(
      () => (
        <SystemCardPopoverContent
          name={cookingSystem.name}
          energySource={cookingSystem.energySink}
          EnergySourceIcon={EnergyIcon}
          limit={cookingSystem.limit}
          coveragePercentage={cookingSystem.coveragePercentage}
          energyDemand={Number(cookingSystem.energyUsePerYr)}
          capitalCost={Number(cookingSystem.capitalCostPerUnit)}
          annualCost={Number(cookingSystem.maintenanceCostPerUnit)}
          coverageFieldTitle={'cooking'}
          designLife={cookingSystem.designLife}
          isLoading={isLoading}
        />
      ),
      [cookingSystem, EnergyIcon, isLoading],
    );

    return (
      <SystemCard
        actions={actions}
        count={count}
        limit={cookingSystem.limit}
        name={cookingSystem.name}
        selected={selected}
        systemImage={COOKING_SYSTEM_IMAGE}
        icons={icons}
        hoverPopover={hoverPopover}
        readOnly={readOnly}
        unitsFixed={isPassiveTechnology(cookingSystem)}
      />
    );
  },
);

CookingUnit.displayName = 'CookingUnit';
